<template>
  <main id="app" v-loading="globalLoading">
    <router-view></router-view>
    <button class="gotoTop" v-show="isGotoTopShow" @click="gotoTop"></button>
  </main>
</template>

<script>

import {mapState} from "vuex";

export default {
  name: 'app',
  data() {
    return {
      scrollY: 0,
    }
  },
  computed: {
    ...mapState({
      globalLoading: state => state.globalLoading.loading,
    }),
    isGotoTopShow() {
      if (this.scrollY > window.innerHeight) {
        
        return true;
      }
      return false;
    },
  },
  methods: {
    gotoTop() {
      const inter = setInterval(() => {
        window.scrollTo(0, window.scrollY - 200);
        if (window.scrollY === 0) {
          clearInterval(inter);
        }
      }, 0);
    },
  },
  mounted() {
    window.addEventListener('scroll', () => this.scrollY = window.scrollY);
  },
}
</script>

<style lang="stylus">
  @import "assets/css/main.styl"
  #app {
    /*height 100%*/
    /*width 100%*/
    height fit-content
    min-height 100vh
    background-color: body-background-color;
    position relative
    /*min-width 1300px*/
    &::before, &::after {
      content ""
      height 0
      display table
    }
    .gotoTop {
      position fixed
      bottom 100px
      right 100px
      height 50px
      width 50px
      background-color rgba(#000, .1)
      border-radius 50%
      border none
      outline none
      display flex
      align-items center
      justify-content center
      &::after {
        content ""
        mask url("assets/images/箭头上.png") no-repeat center
        mask-size 16px
        height 16px
        width 16px
        background-color rgba(#666, .7)
      }
    }
    @media (max-width screenWidth) {
      max-width 100vw
      overflow hidden
      .gotoTop {
        bottom 40px
        right 40px
      }
    }
  }
</style>
